import React from "react";
import { Drawer } from "@mui/material";

import { appBarHeight, consoleBorder, consoleSidebarBg } from "./constants";
import DashboardNavList from "./DashboardNavList";

const DashboardSidebar = ({
  activeKey,
  collapsed,
  drawerWidth,
  items,
  mobileOpen,
  onCloseMobile,
  onSelect,
}) => (
  <>
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", sm: "block" },
        width: drawerWidth,
        flexShrink: 0,
        zIndex: (theme) => theme.zIndex.drawer,
        "& .MuiDrawer-paper": {
          position: "fixed",
          left: 0,
          top: appBarHeight,
          width: drawerWidth,
          height: `calc(100vh - ${appBarHeight})`,
          boxSizing: "border-box",
          bgcolor: consoleSidebarBg,
          border: "none",
          borderRight: `1px solid ${consoleBorder}`,
          boxShadow: "none",
          overflowX: "hidden",
          transition: (theme) =>
            theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.shorter,
            }),
        },
      }}
    >
      <DashboardNavList activeKey={activeKey} collapsed={collapsed} items={items} onSelect={onSelect} />
    </Drawer>

    <Drawer
      variant="temporary"
      open={mobileOpen}
      onClose={onCloseMobile}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: "block", sm: "none" },
        "& .MuiDrawer-paper": {
          width: "min(86vw, 320px)",
          boxSizing: "border-box",
          bgcolor: consoleSidebarBg,
          borderRight: `1px solid ${consoleBorder}`,
          boxShadow: "0 8px 24px rgba(60,64,67,0.24)",
        },
      }}
    >
      <DashboardNavList activeKey={activeKey} items={items} onSelect={onSelect} />
    </Drawer>
  </>
);

export default DashboardSidebar;
